export default __webpack_public_path__ + "static/media/Sleep.d29f9046.svg";